import { mapState, mapGetters } from 'vuex'
import * as type from '@/utvStore/store/mutation-types'
import convertUserInfo from '@/utils/convertUserInfo'
import fetchAccountData from '@/utils/fetchAccountData'
import GuestTemporaryInput from '@/utils/GuestTemporaryInput'

export default {
  props: {
    regist: { type: String, default: '' },
    action: { type: String, default: '' },
    returnPath: { type: String, default: '' },
    reissueKey: { type: String, default: '' }
  },
  data() {
    return {
      $loginForm: undefined,
      email: '',
      password: '',
      errorMessage: '',
      isLoading: false,
      token: window.Laravel.csrfToken
    }
  },
  computed: {
    ...mapState({
      auth: state => state.auth,
      subscriptionInfo: state => state.account.subscription
    }),
    ...mapGetters(['isLoggedIn'])
  },
  mounted() {
    if (this.$refs.loginForm != undefined) {
      this.$loginForm = this.$refs.loginForm
    }
    if (this.regist === '1') {
      this.loginByReissueKey()
    } else if (this.regist === '2') {
      this.preLogin()
    }
  },
  methods: {
    loginByReissueKey() {
      this.isLoading = true
      this.$store
        .dispatch(type.GET_TOKEN_BY_REISSUE_KEY, this.reissueKey)
        .then(this.setTokenToModule)
        .then(this.onLoginSuccess)
        .catch(this.onLoginError)
    },
    switchLoginByReissueKey() {
      this.isLoading = true
      this.$store
        .dispatch(type.GET_TOKEN_BY_REISSUE_KEY, this.reissueKey)
        .then(this.setTokenToModule)
        .then(this.onSwitchSuccess)
        .catch(this.onLoginError)
    },
    login($event) {
      const data = { email: this.email, password: this.password }
      this.$validator.validateAll().then(result => {
        if (result) {
          localStorage.clear()
          sessionStorage.clear()
          this.isLoading = true
          this.$store
            .dispatch(type.GET_NONCE, data)
            .then(this.getTokenByNonce)
            .then(this.setTokenToModule)
            .then(this.onLoginSuccess)
            .catch(this.onLoginError)
            .finally(() => {
              this.isLoading = false
            })
        }
      })
    },
    logout() {
      this.$store.dispatch(type.LOGOUT)
      this.$message({
        message: 'ログアウトしました。',
        type: 'success'
      })
      localStorage.clear()
      sessionStorage.clear()
    },
    getTokenByNonce() {
      return this.$store.dispatch(type.GET_TOKEN_BY_NONCE, this.auth.nonce)
    },
    getTokenByReissueKey() {
      return this.$store.dispatch(type.GET_TOKEN_BY_REISSUE_KEY, this.reissueKey)
    },
    setTokenToModule() {
      const data = {
        reissue_key: this.reissueKey,
        access_token: this.auth.accessToken
      }
      return this.$store.dispatch(type.POST_ACCESS_TOKEN, data)
    },
    onLoginSuccess() {
      this.errorMessage = ''
      if (location.pathname.match(/definitive/) || location.pathname.match(/firstcome\/regist/)) {
      } else {
        if (this.auth.unswitched) {
          localStorage.clear()
          sessionStorage.clear()
        }
      }

      if (this.$loginForm) {
        this.$loginForm.submit()
      } else if (this.auth.accessToken) {
        this.$store.dispatch(type.GET_ACCOUNT, this.auth.accessToken).then(() => {
          //<通常ログインの場合> サーバからredirect先のpathがかえってきた場合はそっちに遷移、それ以外はトップページに遷移(LPと会員トップの出し分けはTopPage.vueで)
          //<サブスク登録遷移のログインの場合> ID会員 -> サブスク登録へ サブスク会員 -> トップへ
          if (this.isSubscRegistering) {
            if (this.subscriptionInfo.active) location.href = '/'
            else location.href = '/subsc/join'
          } else {
            if (this.returnPath) location.href = this.returnPath
            else location.href = '/'
          }
        })
      }
      // ゲスト入力情報を破棄
      GuestTemporaryInput.clear()
      this.$emit('loginSucceed')
    },
    onSwitchSuccess() {
      this.errorMessage = ''
      location.href = `/user/switch_login`

      // ゲスト入力情報を破棄
      GuestTemporaryInput.clear()
      this.$emit('loginSucceed')
    },
    registrationByFirebaseUid(data) {
      this.isLoading = true
      this.$uid = data.uid
      this.$store
        .dispatch(type.REGISTRATION_BY_FIREBASE_UID, data)
        .then(this.getFirebaseTokenByNonce)
        .then(this.redirectToSnsLogin)
        .catch(this.onFirebaseLoginError)
        .finally(() => {
          this.isLoading = false
        })
    },
    redirectToSnsLogin(){
      location.href = `/user/sns/input?login_key=` + this.auth.nonce
      //location.href = `/user/sns/input?login_key=` + this.$uid
      this.$emit('loginSucceed')
    },
    onFirebaseLoginError(error) {
      // 登録済みの場合は、リダイレクトして終わりの例外処理
      if (/is_registed/.test(error.message)) {
        location.href = `/user/login?${error.message}`
        return
      }
      if (error) {
        this.errorMessage = error.message
      }

      this.$message({
        message: error.message,
        type: 'error'
      })

      // ログアウト処理を行う
      this.$store.dispatch(type.LOGOUT)
      this.$emit('loginFailure')
      localStorage.clear()
      sessionStorage.clear()
      throw new Error(error)
    },
    /**
     * ログイン失敗時( 一連の処理でrejectとなった場合 )の処理
     * - エラーメッセージの表示
     * - storeからログイン情報を削除する
     */
    onLoginError(error) {
      if (error) {
        this.errorMessage = error.message
      }

      this.$message({
        message: 'ログインできませんでした。',
        type: 'error'
      })

      // ログアウト処理を行う
      this.$store.dispatch(type.LOGOUT)
      this.$emit('loginFailure')
      localStorage.clear()
      sessionStorage.clear()
      throw new Error(error)
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/login.js